import React, { useCallback, useEffect, useState } from 'react';
import { Col, Input, Row } from 'antd';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { api, endpoints } from '../../api';
import { EditSvg, RemoveSvg } from '../../icons';
import { routerPath } from '../../router/routerPath';
import {
  BlueLayout,
  CustomButton,
  CustomGoBackButton,
  FormBlock,
  FormContainer,
  FormInput,
  FormItem,
  NoButtonContainer,
} from '../../styles/styled';
import { DocumentCategoryType } from '../DocumentCategoryPage/types';
import { EditDocumentCategory } from './styled';

const { TextArea } = Input;

export const EditDocumentCategoryPage = () => {
  const { id } = useParams();
  const [documentFormState, setDocumentFormState] = useState<DocumentCategoryType | null>(null);
  const [currentDocumentState, setCurrentDocument] = useState<DocumentCategoryType | null>(null);
  const [removeDocument, setRemoveDocument] = useState<boolean>(false);
  const navigate = useNavigate();

  const escFunction = useCallback((event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      navigate(-1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false);

    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, [escFunction]);

  useEffect(() => {
    (async () => {
      try {
        if (id) {
          const response = await api.get<DocumentCategoryType>(endpoints.getDocumentCategoryById(id));

          setDocumentFormState(response.data);
          setCurrentDocument(response.data);
        }
      } catch (err) {}
    })();
    // eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    if (removeDocument && documentFormState && id) {
      (async () => {
        try {
          const response = await api.put(endpoints.deleteDocumentById({ id: id }), documentFormState);

          if (response) {
            setCurrentDocument(documentFormState);
            navigate(-1);
          }
        } catch (err) {}
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [removeDocument]);

  return (
    <EditDocumentCategory>
      <BlueLayout>
        <Link to={routerPath.document_category}>
          <CustomGoBackButton>{'<'}</CustomGoBackButton>
        </Link>
        {currentDocumentState?.title}
      </BlueLayout>
      <FormBlock white>
        <Row gutter={[20, 40]}>
          <Col span={24}>
            <FormItem redstar>
              <p>Наименование</p>
              <FormInput
                value={documentFormState?.title}
                onChange={(e) =>
                  setDocumentFormState(documentFormState ? { ...documentFormState, title: e.target.value } : null)
                }
              />
            </FormItem>
          </Col>
          <Col span={24}>
            <FormItem>
              <p>Содержание</p>
              <TextArea
                value={typeof documentFormState?.description === 'string' ? documentFormState.description : ''}
                onChange={(e) =>
                  setDocumentFormState(documentFormState ? { ...documentFormState, description: e.target.value } : null)
                }
              />
            </FormItem>
          </Col>
        </Row>
        <br />

        <FormContainer>
          {documentFormState?.documents.map((el, index) => {
            return (
              <Row key={el.id} gutter={[15, 40]} align="middle">
                <Col span={1}>
                  <div className="numeration">{index + 1}</div>
                </Col>
                <Col span={3}>
                  <FormInput value={el.sort} />
                </Col>
                <Col span={16}>
                  <div className="dark-blue">{el.title}</div>
                </Col>
                <Col className="svg-icons right-side-block" span={4}>
                  <Link to={`${routerPath.editDocument}${el.id}`}>
                    <EditSvg />
                  </Link>
                  <NoButtonContainer>
                    <button
                      onClick={() => {
                        setDocumentFormState({
                          ...documentFormState,
                          documents: documentFormState.documents.filter((e) => e.id !== el.id),
                        });
                      }}
                    >
                      <RemoveSvg />
                    </button>
                  </NoButtonContainer>
                </Col>
              </Row>
            );
          })}
        </FormContainer>
      </FormBlock>
      <div className="to-center">
        <CustomButton onClick={() => setRemoveDocument(true)}>Сохранить</CustomButton>
      </div>

      <CustomButton
        onClick={() => {
          navigate(`${routerPath.newDocument}/${id}`);
        }}
        width="270px"
        lined
      >
        Добавить подраздел
      </CustomButton>
    </EditDocumentCategory>
  );
};
